<template>
  <div>
    <Modal class-name="vertical-center-modal" v-model="isModal" title="生成二维码" width="300">
      <div class="form-wrapper">
        <el-row>
          <el-col :span="6" class="text-right padding-5">
            <label>用户ID：</label>
          </el-col>
          <el-col :span="18" class="padding-5">
            {{ sourceData.sourceId }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="text-right padding-5">
            <label>时效性：</label>
          </el-col>
          <el-col :span="18" class="padding-5">
            <RadioGroup v-model="isPermanent">
              <Radio label="0" >
                <span>临时</span>
              </Radio>
              <Radio label="1">
                <span>永久</span>
              </Radio>
            </RadioGroup>
          </el-col>
        </el-row>
      </div>
      <div slot="footer">
        <div class="footer-wrapper">
          <span class="btn confirm-btn" @click="handelSubmit">生成</span>
        </div>
      </div>
      <Spin size="large" fix v-show="loading"></Spin>
    </Modal>


    <Modal class-name="vertical-center-modal" v-model="isQrcodeModal" title="生成二维码" width="250">
      <p ref="foo" style="text-align:center;margin-bottom:0;">
        <img ref="qrcode" style="width:130px;height:auto"  :src='qrcode'/>
      </p>
      <div slot="footer">
        <div class="footer-wrapper">
          <span class="btn confirm-btn" @click="handelCopy">复制</span>
        </div>
      </div>
      <iframe
        class="hidden"
        id="copyFrame"
        ref="copyFrame"
        name="copyFrame"
        frameborder="0"
        scrolling="no"
        src="/static/copy/copy.html"
      ></iframe>
    </Modal>
  </div>
</template>
<script>
import { Modal, Spin, RadioGroup, Radio } from 'view-design'
import member from  '@/javaApi/kfc/member.js'
const memberModel = new member()
export default {
  name: "CancelDirector",
  components: {
    Modal,
    Spin,
    RadioGroup,
    Radio
  },
  data: function() {
    return {
      isModal: false,
      loading: false,
      sourceData:{},
      isPermanent: "0",
      isQrcodeModal: false,
      qrcode: undefined
    }
  },
  methods: {
    init: function(isModal, row) {
      console.log(1)
      this.loading = true
      this.sourceData = row
      this.isModal = isModal
      this.loading = false
    },
    handelSubmit:function(){
      let param = {
        uuid :this.sourceData.uuid,
        isPermanent: this.isPermanent == 1 ? true : false
      }
      let that = this
      this.loading = true
      // setTimeout(function () {
      //   that.loading = false
      //   that.isQrcodeModal = true
      //   that.qrcode = '/static/img/zitu.3a122ff.png';
      // }, 500);
      memberModel.createQrcode(param).then(response=>{
        let res = response.data
        that.loading = false
        if(res.code == 200){
          that.isQrcodeModal = true
          that.qrcode = res.data
        } else {
          let message = res.message?res.message:'系统异常,请稍后再试'
          that.$message.error(message)
        }
      }).catch(error=>{
        that.loading = false
        console.log(error)
        if(error != 'token invalid'){
          that.$message.error('系统异常请稍后再试')
        }
      })
    },
    handelCopy () {
      try{
        const obj1 = window.frames['copyFrame'] // 获得对应iframe的window对象
        obj1.makeimg = this.qrcode   //传入图片地址
        obj1.domakeimg()  //执行复制函数
        this.$Message.success('复制成功') //进行反馈
        this.isModal = false
        this.isQrcodeModal = false
      } catch (e){
        that.$Message.error('复制失败,请升级浏览器版本！')
        console.log(e)
      }
    }
  }
}
</script>

<style scoped>
>>>.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

>>>.vertical-center-modal .ivu-modal {
  top: 0;
  width: 300px;
}

>>>.vertical-center-modal .ivu-modal-footer {
  border-top: none;
  padding: 12px 18px 30px 18px;
  text-align: right;
}
.form-wrapper .tip-wrap{
  padding: 20px;
}
.footer-wrapper {
  display: flex;
  min-width: 0;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.footer-wrapper .btn {
  display: inline-block;
  border-radius: 4px;
  margin: 0 15px;
  padding: 0px 30px;
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.footer-wrapper .btn.confirm-btn {
  background: #D63036;
  color: #fff;
}

.footer-wrapper .btn.cancel-btn {
  border: 1px solid #eeeeee;
  border-radius: 2px;
  color: #222222;
  background: #F2F2F2;
}


.hidden{
  width: 0;
  height: 0;
  opacity: 0;
  position: absolute;
  top: -1000%;
  left: -1000%;
  z-index: -9999999;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/kfc/member/modal/CreateQrcode.vue